module.exports = __webpack_public_path__ + "static/media/discord.0dc294de.svg";